import VLazyImage from "v-lazy-image/v2/v-lazy-image.es.js";
import { Hyperlink } from "@/components";
import mixins from "vue-typed-mixins";
import { gtmMixin } from "@/mixins";
export default mixins(gtmMixin).extend({
    components: {
        Hyperlink,
        VLazyImage,
    },
    methods: {
        trackEmail() {
            this.gtmClickButton("ask_email");
        },
        trackUlt() {
            this.gtmClickButton("ask_ult");
        },
    },
});
